import domReady from '@wordpress/dom-ready';

domReady(() => {
  const btn = document.querySelector('.back-to-top-btn');
  if (!btn) return;

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  const threshold = 300;
  let timer = null;

  function updateVisibility() {
    if (window.scrollY >= threshold) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', () => {
    if (timer) {
      window.clearTimeout(timer);
    }
    timer = window.setTimeout(updateVisibility, 50);
  });

  updateVisibility();
});
